import initialBillingState from "../billing.initialState";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import { reduxActions as BILLING } from "_constants/billing.constants";

const channels = {
  [BILLING.CHANNELS_STARTED]: (state) => ({
    ...state,
    channels: {
      ...state.channels,
      status: LOADING
    }
  }),

  [BILLING.CHANNELS_SUCCESS]: (state, { payload }) => ({
    ...state,
    channels: {
      ...state.channels,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),

  [BILLING.CHANNELS_FAIL]: (state, { payload }) => ({
    ...state,
    channels: {
      ...state.channels,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [BILLING.CHANNELS_RESET]: (state) => ({
    ...state,
    channels: initialBillingState.channels
  })
};

export default channels;
